import React, { FC, useRef, useState, useEffect } from "react";
import moment from "moment";
import { DatePicker, Radio, Skeleton, Col, Row, Table, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { DownOutlined } from "@ant-design/icons";
import ButtonComponent from "../../../shared/components/ButtonComponent";
// chart
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, getElementsAtEvent } from 'react-chartjs-2';
import { StudentPerformanceModel, StudentPerformanceChartModel, StudentGradePerformanceModel } from "../../../models/DashboardModel/StudentPerformanceModel/studentPerformance.model";
import { serialize } from "serializr";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import DashboardFilter from "../DashboardFilter";
import { DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import { _DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/_dashboardFilter.model";
import { defaultFilter, dateFilterFunc } from "../../../shared/utils/filter";
//style
import "./studentPerformance.scss";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const barchartOptions = {
    responsive: true,
    legend: {
        position: 'bottom',
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
}


interface StudentPerformanceProps { }


const StudentPerformance: FC<StudentPerformanceProps> = (props) => {

    const chartRef = useRef<ChartJS<"bar", number[], string>>(null);
    const [classified, setClassified] = useState("");
    const [chartData, setChartData] = useState<any>({ labels: [], datasets: [] });
    const [loadingChart, setLoadingChart] = useState(true);
    const [loadingTable, setLoadingTable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState<DashboardFilterModel>({});
    const [sections, setSections] = useState<StudentGradePerformanceModel[]>([]);
    const [selectedGrade, setSelectedGeade] = useState({ id: "", label: "" });

    const fetchStudentPerformance = (params?: DashboardFilterModel) => {
        setLoadingChart(true)
        const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
        DashboardService.fetchStudentPerformance(
            payload,
            (contents) => {
                convertChartData(contents, params);
                setLoadingChart(false)
            },
            () => {
                setLoadingChart(false)
                setChartData({ labels: [], datasets: [] })
            },
            () => { }
        );
    };

    // useEffect(() => {
    //     fetchStudentPerformance();
    // }, []);

    const onClick = (event) => {
        if (chartRef.current) {
            const activeIndex = getElementsAtEvent(chartRef.current, event)[0]?.index
            if (activeIndex !== undefined) {
                let dataset: any = chartRef.current.data.datasets[0]
                setSelectedGeade(dataset.ids[activeIndex])
                fetchPerformanceByGrade({ ...defaultFilter, ...filters, classRoom: dataset.ids[activeIndex].id })
            }
        }
    }
    const fetchPerformanceByGrade = (params?: DashboardFilterModel) => {
        setLoadingTable(true)
        const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
        DashboardService.fetchStudentPerformanceByGrade(
            payload,
            (data) => {
                setSections(data);
                setLoadingTable(false)
            },
            () => {
                setSections([]);
                setLoadingTable(false)
            },
            () => { }
        );
    }


    const convertChartData = (contents: StudentPerformanceModel[], params?: any) => {
        let newChartData = serialize(StudentPerformanceChartModel, {
            labels: [],
            datasets: [
                // {
                //     ids: [], label: "Strength", backgroundColor: "#89CDDF", data: []
                // },
                {
                    ids: [], label: "Video", backgroundColor: "#AF65DF", data: []
                },
                {
                    ids: [], label: "PDF", backgroundColor: "#19D4A7", data: []
                },
                {
                    ids: [], label: "Quiz", backgroundColor: "#E98B4D", data: []
                },
                {
                    ids: [], label: "Excercise", backgroundColor: "#E98B4D", data: []
                }
            ]
        }) || [];

        contents.forEach(currentData => {
            newChartData.labels.push(currentData.gradeName)
            newChartData.datasets.forEach(currentValue => {
                currentValue.ids.push({ 'label': currentData?.gradeName, 'id': currentData?.gradeId })
                if (currentValue.label === "Strength")
                    currentValue.data.push(currentData.gradeStrength)
                if (currentValue.label === "Video")
                    currentValue.data.push(currentData.videoViewed)
                if (currentValue.label === "PDF")
                    currentValue.data.push(currentData.pdfViewed)
                if (currentValue.label === "Quiz")
                    currentValue.data.push(currentData.quickQuiz)
                if (currentValue.label === "Quiz")
                    currentValue.data.push(currentData.quickQuiz)
                if (currentValue.label === "Excercise")
                    currentValue.data.push(currentData.excercise)
            })
        })
        setChartData(newChartData)
        const chart = chartRef.current
        chart?.update();

        if (newChartData.labels?.length && newChartData.datasets[0].ids) {
            let dataset = newChartData.datasets[0].ids
            setSelectedGeade(dataset[0])
            fetchPerformanceByGrade({ ...defaultFilter, ...params, classRoom: dataset[0].id })
        }
    }

    // Download Report 
    const handleDownload = (params?: any) => {
        setLoading(true)
        const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
        DashboardService.downloadStudentPerformanceByGrade(
            payload,
            (contents) => { },
            () => { },
            () => { setLoading(false) }
        );
    }

    return (
        <div className="student-performance">

            <div className="student-performance__header">
                <div className="student-performance__header-title">
                    Student Performance{" "}
                    <DashboardFilter
                        autoFilter
                        filterFor="StudentPerformance"
                        applyHandler={(values) => {
                            setFilters(values)
                            setClassified("")
                            fetchStudentPerformance({ ...defaultFilter, ...values })
                            // if (values?.startingDate) {
                            //     fetchStudentPerformance(values)
                            // }
                        }}
                        clearHandler={() => {
                            setClassified("")
                            setFilters({})
                            fetchStudentPerformance()
                        }}
                    />
                </div>
                <div className="student-performance__header-classifieds">
                    <Radio.Group
                        onChange={(e) => {
                            setClassified(e?.target?.value);
                            if (e?.target?.value !== "month") {
                                let dataFilter = dateFilterFunc(e?.target?.value)
                                fetchStudentPerformance({ ...filters, ...dataFilter })
                            }
                        }}
                        value={classified}
                        disabled={(filters?.startingDate || filters?.endingDate) ? true : false}
                    >
                        <Radio.Button value="today">Today</Radio.Button>
                        <Radio.Button value="yesterday">Yesterday</Radio.Button>
                        <Radio.Button value="week">Week</Radio.Button>
                        <Radio.Button value="month">Month</Radio.Button>
                    </Radio.Group>
                    {classified == "month" && (
                        <DatePicker
                            picker={"month"}
                            format="MMM YYYY"
                            suffixIcon={<DownOutlined />}
                            onChange={(e) => {
                                let dataFilter = dateFilterFunc(classified, moment(e))
                                fetchStudentPerformance({ ...filters, ...dataFilter })
                            }}
                        />
                    )}
                </div>
            </div>
            {loadingChart ? (
                <div className="center__wrapper" >
                    <Spin tip="Loading..." className="spin__loader" />
                </div>
            ) : !chartData.labels?.length ? (
                <div className="center__wrapper" >
                    <p className="no__data">No data!</p>
                </div>
            ) : (
                <Row className="most__wrapper" gutter={[24, 24]}>
                    <Col span={12}>
                        <Bar
                            ref={chartRef}
                            options={barchartOptions}
                            data={chartData}
                            onClick={onClick}
                        />
                    </Col>
                    <Col span={12}>
                        {loadingTable ? (
                            <Spin tip="Loading..." className="spin__loader" />
                        ) : !sections?.length ? (
                            <p className="no__data">No data!</p>
                        ) : (
                            <>
                                <div className="grad__header">
                                    <div className="grad__header-title">{selectedGrade?.label}</div>
                                    <ButtonComponent
                                        disabled={loading}
                                        type="text"
                                        iconLeft={<DownloadOutlined />}
                                        buttonContent="Downlaod Report"
                                        onClick={() => handleDownload({ ...defaultFilter, ...filters,classRoom: selectedGrade.id })}
                                    />
                                </div>

                                <Table
                                    dataSource={sections}
                                    columns={[
                                        {
                                            title: 'Section',
                                            dataIndex: 'sectionName',
                                            key: 'name',
                                        },
                                        {
                                            title: 'Video',
                                            dataIndex: 'videoViewed',
                                            key: 'videoViewed',
                                        },
                                        {
                                            title: 'Pdf',
                                            dataIndex: 'pdfViewed',
                                            key: 'pdfViewed',
                                        },
                                        {
                                            title: 'Quick Quiz',
                                            dataIndex: 'quickQuiz',
                                            key: 'quickQuiz',
                                        },
                                        {
                                            title: 'Excercise',
                                            dataIndex: 'excercise',
                                            key: 'excercise',
                                        },
                                        {
                                            title: 'Strength',
                                            dataIndex: 'sectionStrength',
                                            key: 'sectionStrength',
                                        }
                                    ]}
                                    pagination={{ defaultPageSize: 5 }}
                                    size='small'
                                />
                            </>
                        )}

                    </Col>
                </Row>
            )}

        </div>
    )

};

export default StudentPerformance;